import React from "react";
import { Table } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import LanguageToggle from "../LanguageToggle";
import { useGuestContext } from "../../../../contexts/GuestContext";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import { getSessionLabel, LIANG_HUANG_EVENT, LIANG_HUANG_SESSIONS } from "../../../../config/liangHuang2026";

const Step3 = React.forwardRef((props, ref) => {
  const { firstname, lastname, chinesename, email, phone, sessionSelections } = useWizard();
  const { language } = useGuestContext();
  React.useImperativeHandle(ref, () => ({ isValidated: () => true }));

  const selectedSessions = LIANG_HUANG_SESSIONS.filter(
    (session) => sessionSelections[session.field]
  );

  return (
    <div className="wizard-step" ref={ref}>
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteMonk1} alt="" width="40" className="mr-3" />
        {language === "English" ? "Confirm your details" : "請確認所填資料"}
        <img src={cuteMonk2} alt="" width="40" className="ml-3" />
      </p>
      <hr />
      <LanguageToggle />
      <hr />
      <Table striped responsive>
        <tbody>
          <tr><th>{language === "English" ? "Event" : "法會"}</th><td>{LIANG_HUANG_EVENT.title[language]}</td></tr>
          <tr><th>{language === "English" ? "English name" : "英文全名"}</th><td>{firstname} {lastname}</td></tr>
          <tr><th>{language === "English" ? "Chinese name" : "中文姓名"}</th><td>{chinesename || (language === "English" ? "Not provided" : "未填寫")}</td></tr>
          <tr><th>{language === "English" ? "Email" : "電子郵件"}</th><td>{email || (language === "English" ? "Not provided" : "未填寫")}</td></tr>
          <tr><th>{language === "English" ? "Phone" : "聯絡電話"}</th><td>{phone}</td></tr>
          <tr>
            <th>{language === "English" ? "Sessions" : "共修時段"}</th>
            <td>
              {selectedSessions.map((session) => (
                <div key={session.field}>{getSessionLabel(session, language)}</div>
              ))}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
});

export default Step3;
